import type { CartItem, EventLocalizationLanguageData, vat } from '@/types';

import { type CartTicketDTO, mapDtoToTicket } from './cartTicketDTO';

export interface CartItemDTO {
  id: number | string;
  name: string;
  currency: string;
  vat: vat;
  giftcard_allowed: number;
  localizations: Record<string, EventLocalizationLanguageData>; // TODO this is wrong, its not technically EventLocalizationLanguageData. It's localizations DTOs
  eventtime: number;
  eventtime_gmt_offset: number;
  eventtime_override: string | null;
  venuename: string;
  photo1_id: string;
  tickets: CartTicketDTO[];
}

/**
 * Transforms a CartItemDTO object into a CartItem object used in the frontend.
 * @param dto - The CartItemDTO object received from the backend.
 * @returns The transformed CartItem object.
 */
export function mapDtoToCartItem(dto: CartItemDTO): CartItem {
  return {
    ...dto,
    giftcard_allowed: Boolean(dto.giftcard_allowed),
    vat: {
      ticketprice: Number(dto.vat?.ticketprice) || 0,
      ticketfee: Number(dto.vat?.ticketfee) || 0,
      cardfee: Number(dto.vat?.cardfee) || 0,
      shippingfee: Number(dto.vat?.shippingfee) || 0,
    },
    venueName: dto.venuename,
    tickets: dto.tickets.map(mapDtoToTicket),
    upsaleTickets: [],
  };
}
